import styled from 'styled-components';

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;

  > span:last-child {
    font-size: 16px;
    color: ${({ theme }) => theme.colors.black7};
  }
`;

export const BaseContentTitle = styled.span`
  font-size: 30px;
  font-weight: 600;
  line-height: 32px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const HeaderWrapper = styled.div`
  margin: 24px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const BaseContentDescription = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
